export const data = {
  buttons: [
    {
      label: 'Ticket machine',
      id: 'ticket-machine',
    },
    {
      label: 'Mobile app',
      id: 'mobile-app',
    },
    {
      label: 'Telephone',
      id: 'telephone',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/31369adf4f19-tooliconphone.jpg',
  },
  title: 'How did you pay for the parking?',
}
